export default __webpack_public_path__ + "static/media/background.20f30e15.jpg";